/**
 * Asset requests (F5).
 *
 * @see docs/plan/IMPLEMENTATION_PLAN.md task 7.4, PRD §5.6
 */
import type {
  AssetDetail,
  AssetMap,
  AssetSummary,
  CreateAssetRequest,
  ListAssetsQuery,
  UpdateAssetRequest,
} from '@nexus/contracts';

import { api } from '../../../lib/api-client';
import type { PageMeta } from '../../../lib/pagination';

/** A page of assets. */
export interface AssetPage {
  data: AssetSummary[];
  meta: PageMeta;
}

export async function listAssets(query: ListAssetsQuery): Promise<AssetPage> {
  return api.get<AssetPage>('/assets', { query });
}

/** The asset map (F19). */
export async function getAssetMap(): Promise<AssetMap> {
  return api.get<AssetMap>('/assets/map');
}

export async function getAsset(id: string): Promise<AssetDetail> {
  return api.get<AssetDetail>(`/assets/${id}`);
}

export async function createAsset(body: CreateAssetRequest): Promise<AssetDetail> {
  return api.post<AssetDetail>('/assets', body);
}

export async function updateAsset(
  id: string,
  body: UpdateAssetRequest,
): Promise<AssetDetail> {
  return api.patch<AssetDetail>(`/assets/${id}`, body);
}
